<template>
  <div class="headerPage" :class="{ 'is-fixed': isFixed}" :style="'top: ' + (Scrolly-78) + 'px'" style="padding-bottom: 10px;">
    <div class="title-page">
      <ArrowLeftIcon @click="goBack()" />
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item v-for="(bread, i) in $route.meta.breadcrumbs" :key="i" :to="{ name: bread.pathName }">
          {{bread.name}}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="action">
      <slot />
    </div>
  </div>
</template>

<script>
import ArrowLeftIcon from "vue-feather-icons/icons/ArrowLeftIcon";

export default {
  name: "HeaderPage",
  data () {
    return {
      isFixed: false,
      Scrolly: 0
    }
  },
  components: {
    ArrowLeftIcon
  },
  methods: {
    goBack() {
      window.history.back()
    },
    setScrolly (x) {
      this.Scrolly = x
    }
  },
  mounted() {
    let self = this
    window.addEventListener("scroll", function() {
      var top = this.scrollY
      self.setScrolly(top)

      if (top >= 99) {
        self.isFixed = true
      } else {
        self.isFixed = false
      }
    }, false);
  }
}
</script>
